import '../input/button-input';

import { html, LitElement, TemplateResult } from "lit";
import { customElement, property, query, state } from "lit/decorators.js";
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

interface Params {
	offset: number;
	limit: number;
	year?: number;
	tag?: number;
}

@customElement('load-more')
export class LoadMore extends LitElement {

	// Props

	@property({ type: Object })
	params: Params;

	@property({ type: Number })
	total: number;

	@property({ type: String })
	action: string;

	@state()
	_content: string;

	@query('.LoadMore-buttonContainer')
	_buttonContainer: HTMLElement;

	// Lifecycle Hooks

	firstUpdated() {
		
		// add classes 
		this.classList.add('LoadMore');

		// slots
		const slot: HTMLElement = this.querySelector('[slot="content"]');
		this._content = slot.innerHTML;
		slot.remove();
	}

	// Render

	render() {
		return html`
			${ unsafeHTML(this._content) }
			${ (this.total > this.params.offset) ? this.buttonTemplate() : '' }
		`;
	}

	createRenderRoot() { 
        return this;
    }

	// Templates
	buttonTemplate(): TemplateResult {
		return html`
			<div class="LoadMore-buttonContainer">
				<button-input
					name="load-more"
					@click="${() => this._fetch() }">
					<div slot="label">Load More</div>
				</button-input>
			</div>
		`;
	}


	// Methods
	async _fetch() {
		const queryString = new URLSearchParams(
			Object.entries(this.params)
			.map(([key, value]) => [key, String(value)])
		).toString();
		const response = await fetch(`${ this.action }?${ queryString }`);
		if (!response.ok) throw new Error(`Fetch returned ${response.status}`);
		const html = await response.text();
		this._buttonContainer.remove();
		if (html.trim()) this.insertAdjacentHTML('afterend', html);
	}

}